// crypto.randomUUID() only exists in secure contexts (HTTPS/localhost); the local dev
// server can run over plain HTTP, where it's undefined, so fall back to a manual RFC4122 v4 generator.
export const generateUuid = (): string => {
    if (
        typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function'
    ) {
        return crypto.randomUUID()
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0
        const value = char === 'x' ? random : (random & 0x3) | 0x8
        return value.toString(16)
    })
}
